import axios from 'axios'
import { host } from '../../configuraciones'
import { v4 as uuidv4 } from 'uuid';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

var fechaHoy = moment().format('YYYY-MM-DD');

//data inicial
const dataInicial = {
    loading: false,
    activo: false,
    data: {},
    fc_31: {
        fechasolicitud: fechaHoy,
        numerocliente: '',
        fechapropuesta: fechaHoy,
        responsableinstalacion: '',
        correoelectronico: '',
        telefono: '',
        calle: '',
        numeroexterior: '',
        numerointerior: '',
        codigopostal: '',
        colonia: '',
        localidad: '',
        delegacionmunicipio: '',
        estado: '',
        ajustedegrado: false,
        muestra: false,
        muestreo: false,
        ingresomaduracion: false,
        liberacionmaduracion: false,
    },
    anexoAjusteGrado: {},
    anexoMezclaMuestreo: {},
    anexoIngreso: {},
    paginaActiva: 1,
    fc_31Map: {},
    anexoAjusteGradoMap: [],
    anexoMezclaMuestreoMap: [],
    anexoIngresoMap: [],
    anexosMuestreoMap: [],
    anexosIngresoMap: [],
    anexosLiberacionMap: [],
    filesMuestreoMap: [],
    filesIngresoMap: []
}

//types
const LOADING = 'LOADING'
const ACTUALIZAR_FC_31_PAGINA = 'ACTUALIZAR_FC_31_PAGINA'
const RESET_DATA_EXITO = 'RESET_DATA_EXITO'
const ACTUALIZAR_FC_31_ESTATUS_EXITO = 'ACTUALIZAR_FC_31_ESTATUS_EXITO'
const AGREGAR_FC_31_EXITO_MAP = 'AGREGAR_FC_31_EXITO_MAP'
const OBTENER_ID_CLIENTE_EXITO = 'OBTENER_ID_CLIENTE_EXITO'
const OBTENER_FC_31_MAP_EXITO = 'OBTENER_FC_31_MAP_EXITO'
const OBTENER_DETALLE_FC_31_EXITOAT = 'OBTENER_DETALLE_FC_31_EXITOAT'
const ACTUALIZAR_FC_31_SOLICITUD_EXITO = 'ACTUALIZAR_FC_31_SOLICITUD_EXITO'
const OBTENER_FC_31_MAP_EXITO_AT = 'OBTENER_FC_31_MAP_EXITO_AT'
const ACTUALIZAR_FC_31_EXITO_MAP = 'ACTUALIZAR_FC_31_EXITO_MAP'
const GENERAR_OFICIOS_FC31_EXITO = 'GENERAR_OFICIOS_FC31_EXITO'
const ACTUALIZAR_FC_31_SOLICITUD_MODAL_EXITO = 'ACTUALIZAR_FC_31_SOLICITUD_MODAL_EXITO'

export const actualizarFC_31Estatus = createAsyncThunk(
    ACTUALIZAR_FC_31_ESTATUS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusTablas'
            const result = await axios.post(fullUrl, data)
            return true
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerSolicitudDetalleFC_31 = createAsyncThunk(
    OBTENER_DETALLE_FC_31_EXITOAT,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_31/obtenerFormatoFC31_ConDetalle/${idSolicitud}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)

export const agregarMapFC_31Accion = createAsyncThunk(
    AGREGAR_FC_31_EXITO_MAP,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            let muestreoMap = data.muestreoMap
            let ingresoMap = data.ingresoMap
            let liberacionMap = data.liberacionMap
            let archivosMuestreoMap = data.archivosMuestreoMap
            let archivosIngresoMap = data.archivosIngresoMap

            const agregarFC_31Map = host + 'MapSolicitud/agregarMapFC_31_Solicitud'
            const agregarFC_31MuestreoMap = host + 'MapSolicitud/agregarMapFC_31_Muestreo'
            const agregarFC_31IngresoMap = host + 'MapSolicitud/agregarMapFC_31_AnexoIngreso'
            const agregarFC_31LiberacionMap = host + 'MapSolicitud/agregarMapFC_31_AnexoLiberacion'
            const agregarFC_31ArchivoMuestreoMap = host + 'MapSolicitud/agregarMapFC_31ArchivosMuestreo'
            const agregarFC_31ArchivoIngresoMap = host + 'MapSolicitud/agregarMapFC_31ArchivosIngreso'

            const res = await axios.post(agregarFC_31Map, solicitud)
            for (const i in ingresoMap) {
                await axios.post(agregarFC_31IngresoMap, { data: ingresoMap[i] })
            }
            for (const i in muestreoMap) {
                await axios.post(agregarFC_31MuestreoMap, { data: muestreoMap[i] })
            }

            for (const i in liberacionMap) {
                await axios.post(agregarFC_31LiberacionMap, { data: liberacionMap[i] })
            }
            for (const i in archivosMuestreoMap) {
                await axios.post(agregarFC_31ArchivoMuestreoMap, { data: archivosMuestreoMap[i] })
            }
            for (const i in archivosIngresoMap) {
                await axios.post(agregarFC_31ArchivoIngresoMap, { data: archivosIngresoMap[i] })
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarFC_31Solicitud = createAsyncThunk(
    ACTUALIZAR_FC_31_SOLICITUD_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const muestreo = data.archivosMuestreo
            const ingreso = data.archivosIngreso

            const actulizarFC = host + 'FC_31/actualizarFormatoFC31'
            const urlAnexoMuestreo = host + 'FC_31/actualizarArchivFechaMustreo'
            const urlAnexoIngreso = host + 'FC_31/actualizarArchivoFechaIngreso'

            const res = await axios.put(actulizarFC, solicitud)
            let idfc31_solicitudseguimiento = res.data.data.idfc31_solicitudseguimiento

            for (const anexo in muestreo) {
                let resAnexo = await axios.put(urlAnexoMuestreo, { data: muestreo[anexo] })
            }
            for (const anexo in ingreso) {
                let resAnexo = await axios.put(urlAnexoIngreso, { data: ingreso[anexo] })
            }

            return { data: res.data.data }
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerFC_31Map = createAsyncThunk(
    OBTENER_FC_31_MAP_EXITO_AT,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_31_Solicitud/${solicitudId}`
            const res = await axios.get(fullUrl)
            const anexosMap = await obtenerAnexosMap(solicitudId)
            const solicitudMap = {
                data: res.data.data,
                anexoMustreoMap: anexosMap.anexoMuestreoMap,
                anexoIngresoMap: anexosMap.anexoIngresoMap,
                anexoLiberacionMap: anexosMap.anexoLiberacionMap,
                archivoMuestreoMap: anexosMap.archivoMuestreoMap,
                archivoIngresoMap: anexosMap.archivoIngresoMap,
            }
            return solicitudMap
        } catch (error) {
            console.log(error)
        }
    }
)

const obtenerAnexosMap = async (idSolicitud) => {
    try {
        const fullUrl = host + `FC_31/obtenerFormatoFC31_ConDetalle/${idSolicitud}`
        const obtenerMuestreoMap = host + `MapSolicitud/obtenerMapFC_31_Muestreo/`
        const obtenerIngresoMap = host + `MapSolicitud/obtenerMapFC_31_AnexoIngreso/`
        const obtenerLiberacionMap = host + `MapSolicitud/obtenerMapFC_31_AnexoLiberacion/`
        const obtenerArchivosMuestreoMap = host + `MapSolicitud/obtenerMapFC_31_ArchivosMuestreo/`
        const obtenerArchivosIngresoMap = host + `MapSolicitud/obtenerMapFC_31_ArchivosIngreso/`

        const res = await axios.get(fullUrl)
        let muestreo = res.data.data.fc_31_anexomuestreo
        let ingreso = res.data.data.fc_31_anexoingresomaduracion
        let liberacion = res.data.data.fc_31_anexoliberacionmaduracion

        let anexoMuestreoMap = []
        let anexoIngresoMap = []
        let anexoLiberacionMap = []
        let archivoMuestreoMap = []
        let archivoIngresoMap = []

        for (const i in muestreo) {
            const resMap = await axios.get(obtenerMuestreoMap + muestreo[i].idfc31_anexomuestreo)
            anexoMuestreoMap.push(resMap.data.data)
            for (const j in muestreo[i].fc_31archivomuestreo) {
                const resfiles = await axios.get(obtenerArchivosMuestreoMap + muestreo[i].fc_31archivomuestreo[j].idfc_31archivomuestreo)
                if (resfiles.data.data) {
                    resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_31archivomuestreo
                    archivoMuestreoMap.push(resfiles.data.data)
                }
            }
        }
        for (const i in ingreso) {
            const resMap = await axios.get(obtenerIngresoMap + ingreso[i].idfc31_anexoingresomaduracion)
            anexoIngresoMap.push(resMap.data.data)
            for (const j in ingreso[i].fc_31archivoingreso) {
                const resfiles = await axios.get(obtenerArchivosIngresoMap + ingreso[i].fc_31archivoingreso[j].idfc_31archivoingreso)
                if (resfiles.data.data) {
                    resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_31archivoingreso
                    archivoIngresoMap.push(resfiles.data.data)
                }
            }
        }
        for (const i in liberacion) {
            const resMap = await axios.get(obtenerLiberacionMap + liberacion[i].idfc31_anexoliberacionmaduracion)
            anexoLiberacionMap.push(resMap.data.data)
        }


        let anexosMap = {
            anexoMuestreoMap,
            anexoIngresoMap,
            anexoLiberacionMap,
            archivoMuestreoMap,
            archivoIngresoMap
        }
        return anexosMap
    } catch (error) {
        console.log(error);
    }
}
export const actualizarMapFC_31Accion = createAsyncThunk(
    ACTUALIZAR_FC_31_EXITO_MAP,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            let muestreoMap = data.muestreoMap
            let ingresoMap = data.ingresoMap
            let liberacionMap = data.liberacionMap
            let archivosMuestreoMap = data.archivosMuestreoMap
            let archivosIngresoMap = data.archivosIngresoMap

            const actualizarFC_31Map = host + 'MapSolicitud/actualizarMapFC_31_Solicitud'
            const actualizarFC_31MuestreoMap = host + 'MapSolicitud/actualizarMapFC_31_Muestreo'
            const actualizarFC_31IngresoMap = host + 'MapSolicitud/actualizarMapFC_31_AnexoIngreso'
            const actualizarFC_31LiberacionMap = host + 'MapSolicitud/actualizarMapFC_31_AnexoLiberacion'
            const agregarFC_31ArchivoMuestreoMap = host + 'MapSolicitud/agregarMapFC_31ArchivosMuestreo'
            const agregarFC_31ArchivoIngresoMap = host + 'MapSolicitud/agregarMapFC_31ArchivosIngreso'
            const actualizarFC_31ArchivoMuestreoMap = host + 'MapSolicitud/actualizarMapFC_31_ArchivosMuestreo'
            const actualizarFC_31ArchivoIngresoMap = host + 'MapSolicitud/actualizarMapFC_31_ArchivosIngreso'

            const res = await axios.put(actualizarFC_31Map, solicitud)
            for (const i in ingresoMap) {
                await axios.put(actualizarFC_31IngresoMap, { data: ingresoMap[i] })
            }
            for (const i in muestreoMap) {
                await axios.put(actualizarFC_31MuestreoMap, { data: muestreoMap[i] })
            }

            for (const i in liberacionMap) {
                await axios.put(actualizarFC_31LiberacionMap, { data: liberacionMap[i] })
            }
            for (const i in archivosMuestreoMap) {
                if (archivosMuestreoMap[i].idfc_31archivomuestreo != "" && archivosMuestreoMap[i].idfc_31archivomuestreo != null && archivosMuestreoMap[i].idfc_31archivomuestreo != undefined) {
                    let resAnexo = await axios.put(actualizarFC_31ArchivoMuestreoMap, { data: archivosMuestreoMap[i] })
                } else {
                    delete anexo.idfc_31archivomuestreo
                    await axios.post(agregarFC_31ArchivoMuestreoMap, { data: archivosMuestreoMap[i] })
                }
            }
            for (const i in archivosIngresoMap) {
                if (archivosIngresoMap[i].idfc_31archivoingreso != "" && archivosIngresoMap[i].idfc_31archivoingreso != null && archivosIngresoMap[i].idfc_31archivoingreso != undefined) {
                    let resAnexo = await axios.put(actualizarFC_31ArchivoIngresoMap, { data: archivosIngresoMap[i] })
                } else {
                    delete anexo.idfc_31archivoingreso
                    await axios.post(agregarFC_31ArchivoIngresoMap, { data: archivosIngresoMap[i] })
                }
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const generarDocumentosFC_31 = createAsyncThunk(
    GENERAR_OFICIOS_FC31_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'AtencionAClientes/generarOficios'
            const result = await axios.post(fullUrl, data)
            return {}
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerIdCliente = createAsyncThunk(
    OBTENER_ID_CLIENTE_EXITO,
    async (idlogin) => {
        try {
            const fullUrl = host + `AnexoUsuario/obtenerClientePorIdLogin/${idlogin}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

//Para guardar la información del modal en atención a clientes
export const actualizarFC_31SolicitudModal = createAsyncThunk(
    ACTUALIZAR_FC_31_SOLICITUD_MODAL_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data }
            const actualizarFC_31 = host + 'FC_31/actualizarFormatoFC31'
            const res = await axios.put(actualizarFC_31, solicitud)
            return res
        } catch (error) {
            console.log(error)
        }
    }
)


export const fc31Slice = createSlice({
    name: 'fc31Slice',
    initialState: dataInicial,
    reducers: {
        actualizarPaginaActivaFC_31(state, { payload }) {
            state.paginaActiva = payload
        },
        guardarCambiosFC_31Solicitud(state, { payload }) {
            state.fc_31 = payload
        },
        agregarFC_31AnexoAjuste(state, { payload }) {
            state.anexoAjusteGrado = payload
        },
        agregarFC_31AnexoMuestra(state, { payload }) {
            state.anexoMezclaMuestreo = payload
        },
        agregarFC_31AnexoIngreso(state, { payload }) {
            state.anexoIngreso = payload
        },
        resetDataFC_31(state, { payload }) {
            return dataInicial
        },
        setModoVerDetalleFC_31(state, { payload }) {
            state.modoVerDetalle = payload
        },
        setModoRecibidasCorregidasFC_31(state, { payload }) {
            state.modoRecibidasCorregidas = payload
        },
        setModoProcesoFC_31(state, { payload }) {
            state.modoProceso = payload
        },
    },
    extraReducers: {
        [obtenerSolicitudDetalleFC_31.fulfilled]: (state, { payload }) => {
            state.data = payload
        },
        [agregarMapFC_31Accion.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_31Estatus.fulfilled]: (state, { payload }) => {
        },
        [obtenerIdCliente.fulfilled]: (state, { payload }) => {
        },
        [obtenerFC_31Map.fulfilled]: (state, { payload }) => {
            state.fc_31Map = payload.data
            state.anexosMuestreoMap = payload.anexoMustreoMap
            state.anexosIngresoMap = payload.anexoIngresoMap
            state.anexosLiberacionMap = payload.anexoLiberacionMap
            state.filesMuestreoMap = payload.archivoMuestreoMap
            state.filesIngresoMap = payload.archivoIngresoMap
        },
    },
})

//actions
export const {
    actualizarPaginaActivaFC_31,
    guardarCambiosFC_31Solicitud,
    agregarFC_31AnexoAjuste,
    agregarFC_31AnexoMuestra,
    agregarFC_31AnexoIngreso,
    resetDataFC_31,
    setModoVerDetalleFC_31, setModoRecibidasCorregidasFC_31, setModoProcesoFC_31

} = fc31Slice.actions

export const FC31ReducerAtencionACliente = fc31Slice.reducer